import React from 'react';
import './about.css';

const About = () => {
    return (
        <div className="about d-flex align-items-center justify-content-center">
            <div className="text-bg-color text-white text-center">
                <h1>We provide the best courier services for you! </h1>
                <h3>You can simply click and order any service.</h3>
                <p>
                    You can simply contact the courier office. and know about
                    your service
                </p>
                <p>You can visit courier office and purchase your service</p>
                <p>Also, you can get services for emergency courier.</p>
            </div>
        </div>
    );
};

export default About;
